import { Chip, Tooltip } from "@mui/material";
import classNames from "classnames";
import type { ReactNode } from "react";

interface NavigationBlockWithBadgeProps {
    /** Icon component to display */
    icon: ReactNode;
    /** Label text */
    label: string;
    /** Badge count (0 or undefined = no badge) */
    badgeCount?: number;
    /** Tooltip text for the badge */
    badgeTooltip?: string;
    /** Whether the navigation is collapsed (icons only) */
    isCollapsed?: boolean;
}

/**
 * Reusable navigation block with icon, label and optional badge
 * Used for notifications, pending imports, declarations, etc.
 * Hides label when collapsed
 */
const NavigationBlockWithBadge = ({
    icon,
    label,
    badgeCount = 0,
    badgeTooltip,
    isCollapsed = false,
}: NavigationBlockWithBadgeProps) => {
    const showBadge = badgeCount > 0;
    const displayCount = badgeCount > 9 ? "9+" : badgeCount;

    return (
        <div
            className={classNames("navigation-block-with-badge", {
                "navigation-block-with-badge--collapsed": isCollapsed,
            })}
        >
            <div className="navigation-link__icon">{icon}</div>
            <span className="navigation-link__label">{label}</span>
            {showBadge && (
                <Tooltip title={badgeTooltip || ""} arrow>
                    <Chip
                        label={displayCount}
                        className={classNames({
                            "medium-padding": badgeCount < 10 && badgeCount > 1,
                            "small-padding": badgeCount > 9,
                        })}
                    />
                </Tooltip>
            )}
        </div>
    );
};

export default NavigationBlockWithBadge;
